import styled from 'styled-components';

export const LoginSignupStyled = styled.div`
  height: 100%;
  width: 100vw;
  padding-left: 4rem;
  padding-right: 4rem;
  transition: transform 1s;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  box-sizing: border-box;
`